import React, { useState } from "react";
import axios from "axios";
import "./ConfirmForm.scss";
import InputForm from "./InputForm";
import orchidImage from "./images/orchid-2.webp"

function ConfirmForm({ t }) {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [coming, setComing] = useState(true);
  const [wantHotelReservation, setWantHotelReservation] = useState(false);

  const [loading, setLoading] = useState(false);

  function clearForm() {
    setLastName("");
    setName("");
    setEmail("");
  }

  async function submitForm(e) {
    e.preventDefault();

    if (!name || !lastName) {
      alert(t.alertMissing);
      return;
    }

    //TODO: TEST HERE
    const webhookUrl = "https://hook.eu2.make.com/auwl4swbi7pv7ekiov36sv9v9gfgnpai";

    const data = {
      name: name,
      lastName: lastName,
      email: email,
      coming: coming,
      wantHotelReservation: coming ? wantHotelReservation : "",
    };

    try {
      setLoading(true);
      let res = await axios.post(webhookUrl, data);

      if (res.status === 200) {
        setLoading(false);
        setIsSent(true);

        if (window) {
          window.scrollTo(0, window.pageYOffset - 500);
        }
      }
    } catch (error) {
      setLoading(false);
      alert(t.alertError);
      clearForm();
    }
  }

  if (isSent) {
    return (
      <section className="confirm-form-section p-top-12 p-bottom-12">
        <div className="flex flex-justify-center">
          <div className="col-6 col-12-xs col-12-sm col-12-md col-10-lg">
            <div className="modern-form p-4 p-2-xs p-top-6 p-top-3-xs text-center">
              <div className="text-lg m-bottom-1">
                {t.thankYou}
              </div>
              {coming && (
                <div>
                  <span className="text-primary text-bold">{name}</span>,
                  {" "}{t.confirmedSuccess}
                </div>
              )}
              {!coming && (
                <div>
                  <span className="text-primary text-bold">{name}</span>, {t.blackMark}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section>
      <div className="flex flex-justify-center">
        <div className="col-6 col-12-xs col-12-sm col-12-md col-10-lg relative">
          <img 
            src={orchidImage} 
            alt="Orchid decoration" 
            className="orchid-decoration hidden-xsm"
          />
          <form
            className="modern-form p-4 p-2-xs p-top-6 p-top-3-xs"
            onSubmit={(e) => submitForm(e)}
          >
            <InputForm
              id="firstname"
              type="text"
              text={t.firstName}
              isRequired={true}
              onChange={setName}
            />

            <InputForm
              id="lastname"
              type="text"
              text={t.lastName}
              isRequired={true}
              onChange={setLastName}
            />

            <InputForm
              id="email"
              type="email"
              text={t.email}
              isRequired={false}
              onChange={setEmail}
            />
            <div className="text-lg m-bottom-1">{t.canYouAttend}</div>
            <ul className="text-lg p-2">
              <li>
                <input
                  type="radio"
                  value="true"
                  checked={coming}
                  onChange={() => setComing(true)}
                />
                <label>{t.yes}</label>
              </li>

              <li>
                <input
                  type="radio"
                  value="false"
                  checked={!coming}
                  onChange={() => setComing(false)}
                />
                <label>{t.noSorry}</label>
              </li>
            </ul>

            {coming && (
              <div>
                <div className="text-lg font-weight-700 text-primary text-sm-xsm m-top-4 m-bottom-2">
                 {t.forGuestsOutsideVarna}
                </div>
                <div className="text-lg m-bottom-1">
                 {t.hotelQuestion}
                </div>
                <div className="text-sm m-bottom-1">
                 {t.preferentialPrices} <span className="font-weight-700 text-primary">{t.preferentialPricesBold}</span>{t.preferentialPricesEnd}
                </div>
                <ul className="text-lg p-2">
                  <li>
                    <label>
                      <input
                        type="radio"
                        value="true"
                        checked={wantHotelReservation}
                        onChange={() => setWantHotelReservation(true)}
                      />
                      {t.yes}
                    </label>
                    {wantHotelReservation && (
                      <div className="text-sm m-top-1 m-left-3">
                       {t.hotelContactText} <br/> <strong>+359 898 637 937</strong>.
                      </div>
                    )}
                  </li>
                  <li>
                    <label>
                      <input
                        type="radio"
                        value="false"
                        checked={!wantHotelReservation}
                        onChange={() => setWantHotelReservation(false)}
                      />
                      {t.noSorry}
                    </label>
                  </li>
                </ul>
              </div>
            )}

            <div className="m-top-4 m-bottom-2 text-center-xs">
              <button
                id="submit"
                type="submit"
                className="confirm-btn relative"
              >
                {t.submit}
                {loading && (
                  <div className="loading">
                    <div className="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ConfirmForm;
